module.exports = __webpack_public_path__ + "img/Gewaehrleistungslabel.ef098331.svg";